const accountCards = document.querySelectorAll('.account__card');

const styleContent = `
  .a__returnLink {
    flex-grow: 1;
    text-align: right;
  }
  .a__returnLink:after {
    content: '';
    display: inline-block;
    margin-left: 0.5rem;
    margin-right: 0.5rem;
  }
  .a__returnLink__:hover {
    color: #fff;
    text-decoration: none;
  }
  .a__returnLink__:active,
  .a__returnLink__:visited,
  .a__returnLink__:focus {
    color: #fff;
  }
`;
const styleSheet = document.createElement('style');
styleSheet.innerHTML = styleContent;
document.head.append(styleSheet);
const topEl = document.querySelector('.account__heading');

accountCards.forEach((accountCard) => {
  const header = accountCard.querySelector('.account__card__header');
  const titleEl = accountCard.querySelector('h3');
  if (!header) return false;

  const orderLink = header.querySelectorAll('a')[0].href;

  const params = new URLSearchParams(orderLink.split('?')[1]);
  const orderId = params.get('orderId');

  const hiddenP = accountCard.querySelector('p[hidden]');
  const postalCode = hiddenP ? hiddenP.textContent : '';

  const dateEl = accountCard.querySelectorAll('.account__card__data')[0].querySelector('dd');
  const dateOriginStr = dateEl?.innerHTML;

  let dateStr = dateOriginStr;

  if (dateOriginStr && dateOriginStr?.indexOf('.') > -1) {
    dateStr = dateOriginStr.split('.').reverse().join('-');
  }

  if (orderId && dateStr) {
    const aLink = document.createElement('a');
    aLink.onclick = () => {
      if (topEl) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    };

    aLink.classList.add('a__returnLink', 'account__card__title__link');
    aLink.style.color = '#000';
    aLink.innerHTML = 'Retur';
    aLink.href = `#/select-products?order=${orderId}&postcode=${postalCode}`;
    titleEl?.parentNode?.insertBefore(aLink, titleEl.nextSibling);
  }

  return;
});
